export default __webpack_public_path__ + "static/cardTabImg4-7986a5afebacb7f5edbc4dda8bb74d3e.webp";